import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { regionInputFor } from '../api/accountInfo';
import FirmwarePage from '../features/firmware/FirmwarePage';

export default function FirmwareRoute() {
  const [searchParams] = useSearchParams();
  const deviceId = (searchParams.get('deviceId') || '').trim();
  const childDeviceId = (searchParams.get('childDeviceId') || '').trim();
  const initialDevice = deviceId && childDeviceId ? {
    deviceId,
    childDeviceId,
    regionId: regionInputFor(searchParams.get('regionId')),
  } : null;

  return <FirmwarePage key={JSON.stringify(initialDevice)} initialDevice={initialDevice} />;
}
